import React from "react";
import { useNavigate } from "react-router-dom";
import { mediaKits } from "../data/media_kit_data";
import "../styles/media_kit.css";

function MediaKit() {
  const navigate = useNavigate();
  document.title = "MEDIA-KIT CGES.CLUB";

  return (
    <div className="media-kit-page">
      <div className="media-kit-hero">
        <h2 className="uk-text-lead">Media Kit</h2>
        <p>Choose a kit to view approved assets and downloads.</p>
      </div>

      <div className="uk-grid uk-grid-small" data-uk-grid>
        {mediaKits.map((kit) => (
          <div
            key={kit.id}
            className="uk-width-1-2@l uk-width-1-2@m uk-width-1-1@s"
          >
            <article
              className="media-kit-v2-card"
              role="button"
              tabIndex={0}
              onClick={() => kit.islive ? navigate(`/media-kit/${kit.id}`):null}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  navigate(`/media-kit/${kit.id}`);
                }
              }}
            >
              <div className="media-kit-v2-card__icon">
                <i className={kit.icon}></i>
              </div>

              <div className="media-kit-v2-card__content">
                <div className="media-kit-v2-card__title">{kit.title}</div>
                <div className="media-kit-v2-card__subtitle">{kit.description}</div>
                <div className="media-kit-v2-card__meta">
                  <span>{kit.assets.length} assets</span>
                </div>
              </div>

              <div className="media-kit-v2-card__action">
                <span>{kit.islive ?'View':'coming soon'}</span>
              </div>
            </article>
          </div>
        ))}
      </div>
    </div>
  );
}

export default MediaKit;
